<div id="dashboard-project" class="page-layout simple right-sidenav" fxLayout="row">

  <div class="center" fxFlex>

    <!-- <div class="header thin-header p-12 p-sm-24" fxLayout="row" fxLayoutAlign="space-between"
      style="background-color: white !important;">

      <div fxFlex="" fxLayoutAlign="start center">
      </div>
      <button mat-icon-button class="settings" (click)="settings.toggle()">
        <mat-icon style="color: #069bde !important; ">settings</mat-icon>
      </button>
    </div> -->
    <mat-progress-bar *ngIf="isLoading" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
    </mat-progress-bar>

    <div>
      <mat-sidenav-container class="settingsTodo">
        <div class="mainDiv">
          <div class="nav">
            <mat-card class="card-nav" style="overflow: auto; height: 90vh">
              <div style="height: 50px;text-align: end;padding: 13px;">
                <!-- <button mat-icon-button (click)="settings.toggle()"> -->
                <mat-icon style="color: #069bde !important;cursor: pointer;" (click)="settings.toggle()">
                  settings
                </mat-icon>
                <!-- </button> -->
              </div>
              <div class="todo-nav" *ngIf="selectedProject">
                <div *ngIf="preference">
                  <div *ngFor="let item of defaultProjects">
                    <a *ngIf="showMe(item)" [class.active]="selectedProject?.id === item.id"
                      (click)="selectedProject = item">
                      <table style="width: 100%;">
                        <tr>
                          <td style="width: 82%;">
                            <mat-icon>{{item.icon}}</mat-icon>
                            {{item.name}}
                          </td>
                          <td style="width: 17%;">
                            <span class="badge" *ngIf="getDueCount(item)">{{getDueCount(item)}}</span>
                            <!-- </td>
                        <td> --> &nbsp;&nbsp;&nbsp;
                            <span style="float: right">{{getCount(item)}}</span>
                          </td>
                        </tr>
                      </table>
                    </a>
                  </div>
                </div>

                <div *ngFor="let project of projects">
                  <a *ngIf="project.default" [class.active]="selectedProject.id === project.id"
                    (click)="selectedProject = project">
                    <table style="width: 100%;">
                      <tr>
                        <td style="width: 82%;">
                          <mat-icon>home</mat-icon>
                          {{project?.name}}
                        </td>
                        <td style="width: 17%;">
                          <span class="badge" *ngIf="getDueTask(project.tasks)">{{getDueTask(project.tasks)}}</span>
                          <!-- </td>
                        <td> -->
                          <span style="float: right">{{getCompletedTask(project.tasks)}}</span>
                        </td>
                      </tr>
                    </table>
                  </a>
                </div>

                <br>

                <div *ngFor="let project of projects">
                  <a *ngIf="!project.default" [class.active]="selectedProject.id === project.id"
                    (click)="selectedProject = project">
                    <table style="width: 100%;">
                      <tr>
                        <td style="width: 82%;">
                          <mat-icon>list_alt</mat-icon>
                          {{project?.name}}
                          <!-- &nbsp; -->
                          <mat-icon style="text-align: start" *ngIf="project.shared_with">supervised_user_circle
                          </mat-icon>
                        </td>
                        <td style="width: 17%;">
                          <span class="badge" *ngIf="getDueTask(project.tasks)">{{getDueTask(project.tasks)}}</span>
                          <!-- </td>
                        <td> -->
                          <span style="float: right">{{getCompletedTask(project.tasks)}}</span>
                        </td>
                      </tr>
                    </table>
                  </a>
                </div>

                <div class="add-new">
                  <mat-icon>add</mat-icon>
                  <input #newProject type="text" (change)="createProject($event.target.value)" placeholder="New List">
                </div>
                <br>
                <br>
              </div>
            </mat-card>
          </div>


          <div class="todo-content" *ngIf="selectedProject">
            <mat-card [ngSwitch]="selectedProject.id">
              <todo-my-day *ngSwitchCase="'1'" [projects]="projects" (update)="getAllProject()"
                [preference]="preference">
              </todo-my-day>
              <todo-important *ngSwitchCase="'2'" [projects]="projects" (update)="getAllProject()"
                [preference]="preference">
              </todo-important>
              <todo-planned *ngSwitchCase="'3'" [projects]="projects" (update)="getAllProject()"
                [preference]="preference">
              </todo-planned>
              <todo-priority *ngSwitchCase="'4'" [projects]="projects" (update)="getAllProject()"
                [preference]="preference">
              </todo-priority>
              <assigned-to-me *ngSwitchCase="'5'" [projects]="projects" (update)="getAllProject()"
                [preference]="preference">
              </assigned-to-me>
              <todo-list *ngSwitchDefault [project]="selectedProject" [projects]="projects" (update)="getAllProject()"
                (remove)="onRemove()" [preference]="preference">
              </todo-list>
            </mat-card>
          </div>
        </div>
        <mat-sidenav mode="side" #settings position="end" class="sideNav">
          <mat-card class="settingsNav">
            <h5>
              Settings
              <button mat-icon-button (click)="settings.toggle()">
                <mat-icon>close</mat-icon>
              </button>
            </h5>
            <main>
              <todo-settings-side-nav [preference]="preference" (update)="getPreferences()"></todo-settings-side-nav>
            </main>
          </mat-card>
        </mat-sidenav>
      </mat-sidenav-container>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-details/todo-details.component.html